import React from 'react'
import UpperHeader from '../components/UpperHeader'
import Header from '../components/Header'
import Report from '../components/Report'
import Footer from '../components/Footer'
import { useAlert } from "react-alert";

export default function Observer() {
    let alert = useAlert();
    const [files, setFiles] = React.useState([]);

    React.useEffect(() => {
        getObserver()
    }, [])

    const getObserver = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getObserver`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setFiles(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los archivos", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div>
            <UpperHeader child={false} />
            <Header />
            <Report />
            <div className="text-center p-2">
                <p className='colorblue'>
                    <h2 className='fw-bold fst-italic'>
                        Observador Ciudadano
                    </h2>
                </p>
            </div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <div className="container">
                {files && files.map((val, i) => {
                    return <div key={i} className="boardContainer">
                        <a href={val.routeimage} className='noLink' style={{ color: "black" }} rel="noreferrer" target='_blank' download>
                            <div className="singleboardContainer bodyBackLogo text-center">
                                <img src={`${val.route.split(".")[1]}icon.png`} alt="Icono Descarga" style={{ height: 50, width: 45 }} />
                                <br /><br />
                                <p>{val.route.substr(5, 100)}</p>
                            </div>
                        </a>
                    </div>
                })}
            </div>
            <Footer showmap={false} />
        </div>
    )
}
